(function () {
    'use strict';

    angular
        .module('app.interestingCountry')
        .controller('interestingCountryCtrl', ['$scope', '$rootScope', 'interestingCountryService', '$modal', 'localStorageService', '$location',
            function ($scope, $rootScope, interestingCountryService, $modal, localStorageService, location) {
                $scope.countries = [];
                $scope.numberOfInterestingCountry = 0;
                var definitions = angular.copy($rootScope.definitions);
                angular.forEach(definitions.countries, function(country) {
                    $scope.countries.push(country);
                    if(country.isActive == 1) {
                        $scope.numberOfInterestingCountry ++;
                    }
                })

                $scope.selectInterestingCountry = function(country) {
                    if(country.isActive == 1) {
                        country.isActive = 0;
                    } else {
                        country.isActive = 1;
                    }
                }

                $scope.updateInterestingCountry = function() {
                    var interestingCountryParam = {
                        interestingCountry: $scope.countries
                    }

                    interestingCountryService.updateInterestingCountry(interestingCountryParam, true)
                        .then(function(response) {
                            location.reload('admin/interestingCountry');
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.interestingAllCountries = function() {
                    angular.forEach($scope.countries, function(country) {
                        country.isActive = 1;
                    })

                    var interestingCountryParam = {
                        interestingCountry: $scope.countries
                    }

                    interestingCountryService.updateInterestingCountry(interestingCountryParam, true)
                        .then(function(response) {
                            location.reload('admin/interestingCountry');
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.removeAllInterestingCountries = function() {
                    angular.forEach($scope.countries, function(country) {
                        country.isActive = 0;
                    })

                    var interestingCountryParam = {
                        interestingCountry: $scope.countries
                    }

                    interestingCountryService.updateInterestingCountry(interestingCountryParam, true)
                        .then(function(response) {
                            location.reload('admin/interestingCountry');
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }
            }
        ])
})();